import barLoader from "../../assets/Images/BarLoader.gif";
export default function BarLoader() {
    return (
          <div className="min-h-[70vh] w-full flex items-center justify-center">
            <img src={barLoader} alt="Loading..." className="h-[160px] w-auto" />
        </div>
    )
}